<div class="fix-action-dialog">
	<h1 mat-dialog-title>{{content.title}}</h1>
	<mat-dialog-content fxLayout="column">
		<mat-card>
			<mat-card-header>
				<div class="description-text">{{content.description}}</div>
			</mat-card-header>
			<mat-card-content>
				<div>{{content.username}}</div>
				<form #form="ngForm" fxLayout="column" fxLayoutAlign="space-between" novalidate>

					<mat-form-field class="input-text">
						<mat-label>Password...</mat-label>
						<input #password="ngModel" [(ngModel)]="content.password" matInput maxlength="1000" minlength="6" name="password" placeholder="パスワード" required type="password">
						<mat-hint>6文字以上1000文字まで</mat-hint>
						<mat-error *ngIf="password.errors?.['required'];">入力してください</mat-error>
						<mat-error *ngIf="password.errors?.['maxlength'];">長すぎます</mat-error>
						<mat-error *ngIf="password.errors?.['minlength'];">短かすぎます</mat-error>
					</mat-form-field>
					<mat-form-field class="input-text">
						<mat-label>Password Again...</mat-label>
						<input #confirm_password="ngModel" [(ngModel)]="content.confirm_password" [validateEquals]="password" matInput name="confirm_password" placeholder="パスワード(確認)" required type="password">
						<mat-hint>6文字以上1000文字まで</mat-hint>
						<mat-error *ngIf="confirm_password.errors?.['required'];">確認用パスワードを入力してください</mat-error>
						<mat-error *ngIf="confirm_password.errors?.['validateEquals'];">確認用パスワードが一致しません</mat-error>
					</mat-form-field>
				</form>
			</mat-card-content>
		</mat-card>
	</mat-dialog-content>
	<div class="spacer"></div>
	<mat-dialog-actions fxLayout="row" fxLayoutAlign="space-around" style="margin:6px;">
		<button [disabled]="isProgress" color="warn" mat-dialog-close="" mat-raised-button><span translate>キャンセル</span></button>
		<button (click)="onAccept()" [disabled]="form.invalid || isProgress" color="primary" mat-raised-button>OK</button>
	</mat-dialog-actions>
</div>
